import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { ProvisionRunSection } from '@/features/ledger/provision-run'

/**
 * Provisioning, as an addressable screen of its own.
 *
 * `POST /loans/classification-runs` is gated on `ledger.provision.run` — a ledger permission on a
 * route the loans module owns — and it is the only write here that puts a journal into the general
 * ledger *without a countersignature*: a manual journal is the other way in and is countersigned,
 * so this one executes on the click. It is separated out because it is a month-end job with its own
 * audience: the person who runs it is looking at provisioning, not at business days.
 *
 * The whole screen refuses below `lg`.
 */
export function LedgerProvisioningPage() {
  return (
    <>
      <Link
        to="/ledger"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All of the ledger
      </Link>

      <PageHeader
        title="Provisioning"
        description="Classify a branch's live rounds against the scheme in force and post the movement in the loan-loss allowance. The movement, never the level — a book that has not moved posts nothing."
      />

      <ProvisionRunSection />
    </>
  )
}
